import React, { useEffect } from "react";
import { Paper, Card, CardContent, makeStyles } from "@material-ui/core";
import Header from "./Header";
import UsersList from "./UsersList";
import Search from "./Search";
import CreateModal from "./CreateModal";
import DeleteModal from "./DeleteModal";
import ViewModal from "./ViewModal";

import { useDispatch } from "react-redux";
import externalUsersActions from "../../../redux/actions/externalUsers";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function Users() {
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    const start = async () => {
      dispatch(externalUsersActions.fetchUsers());
    };
    start();
  }, []);

  return (
    <Paper className={classes.root}>
      <Card>
        <CardContent>
          <Header />
          <CreateModal />
          <DeleteModal />
          <ViewModal />
          <Search />
          <UsersList />
        </CardContent>
      </Card>
    </Paper>
  );
}
